import { AppConfig } from '@/core/types/AppConfig.ts'
import { env } from '@/env.ts'
import { OneMB } from '@/core/constants/sizes.ts'
import { systemModulesConf } from '@/config/systemModules.ts'
import { envListToArray } from '@/core/utils/env.ts'
import { mapListToOptions } from '@/core/utils/general.ts'
import { SystemModule } from '@/core/types/SystemModule.ts'
import { filterListOut } from '@/core/utils/listProcessing.ts'

const filterOutMarketplace = (m: SystemModule) =>
  m.systemName !== 'marketplace' || env.VITE_APP_SHOW_MARKETPLACE === 'true'

const filterOutDraw = (m: SystemModule) =>
  m.systemName !== 'draw' || env.VITE_APP_SHOW_DRAW === 'true'

export const appConfig: AppConfig = {
  appName: 'Weppa',
  apiUrl: env.VITE_APP_API_URL,
  walletApiUrl: env.VITE_APP_WALLET_API_URL,
  managementApiUrl: env.VITE_APP_MANAGEMENT_API_URL,
  marketPlaceApiUrl: env.VITE_APP_MARKETPLACE_API_URL,
  apiVersion: env.VITE_APP_API_VERSION,
  walletApiVersion: env.VITE_APP_WALLET_API_VERSION,
  weppa1ReportsUrl: env.VITE_APP_WEPPA1_REPORTS_URL,
  appleBrandId: env.VITE_APP_APPLE_BRAND_ID,
  maxClientWalletRecharge: env.VITE_APP_MAX_CLIENT_WALLET_RECHARGE,
  weppaCommercialAllyId: env.VITE_APP_WEPPA_COMMERCIAL_ALLY_ID,
  imageSizeLimit: 5 * OneMB,
  imgExtensions: ['image/jpg', 'image/jpeg', 'image/png'],
  dateFormat: 'DD/MM/YYYY',
  timeFormat: 'HH:mm',
  apiDateFormat: 'DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  currencyAlign: 'left',
  verifyCodeCooldownInSec: 30,
  verifyEqualityAssignSearchCooldownInSec: 60,
  verifyCreditPreassignedCooldownInSec: 15,
  toasts: { duration: 5000, position: 'top-right' },
  search: { delay: 900 },
  pagination: { rowsPerPageOptions: [10, 15, 20], defaultValue: 20 },
  showMarketplace: env.VITE_APP_SHOW_MARKETPLACE === 'true',
  showDraw: env.VITE_APP_SHOW_DRAW === 'true',
  systemModules: filterListOut(systemModulesConf, [
    filterOutMarketplace,
    filterOutDraw
  ]),
  defaultAssembler: '',
  showRentabilityPolicy: env.VITE_APP_SHOW_RENTABILITY_POLICY === 'true',
  defaultMapGeoLocation: { lat: 7.02009, lng: -66.003658 },
  motorSupplierId: '5',
  vehicleClasses: mapListToOptions(
    envListToArray(env.VITE_APP_VEHICLE_CLASSES)
  ),
  vehicleColors: mapListToOptions(envListToArray(env.VITE_APP_VEHICLE_COLORS)),
  accountTypes: mapListToOptions(envListToArray(env.VITE_APP_ACCOUNT_TYPES)),
  maritalStatus: mapListToOptions(envListToArray(env.VITE_APP_MARITAL_STATUS))
}
